<template>
  <div v-if="workData != null">
    <template v-if="fullSizable">
      <select :style="{'max-width': maxChartWidth+'px'}" v-for="selectNum in this.maxLevel" :key="selectNum" v-model="activeSelection[selectNum-1]">
        <option v-for="optionData, idx in getLevelList(selectNum-1)" :key="optionData" :value="optionData" :selected="idx == 0">{{ optionData }}</option>
      </select>
      <GanttChartPainter
                          :fullSizable="fullSizable"
                          :maxChartWidth="maxChartWidth"
                          :maxDiagramHeight="maxDiagramHeight"
                          :isVertical="isVertical"
                          :drawData="this.workData[activeGroup]"
                          @open_full_size="openFullSize()"
      />
    </template>
    <template v-else>
      <GanttChartPainter v-for="(group, name) in this.workData" :key="name"
                          :fullSizable="fullSizable"
                          :maxChartWidth="maxChartWidth"
                          :maxDiagramHeight="maxDiagramHeight / 2"
                          :isVertical="isVertical"
                          :drawData="group"
                          @open_full_size="openFullSize()"
      />
    </template>
  </div>
</template>

<script type="text/javascript">
import GanttChartPainter from './ChartPainters/GanttChartPainter.vue';

function hslToHex(h, s, l) {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0'); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

function getParentViewList(field) {
  const ans = [];
  while (field != null) {
    ans.unshift(field.view);
    field = field.parent;
  }
  return ans;
}

const selfComponent = {
  components: {
    GanttChartPainter,
  },
  data: () => ({
    maxLevel: 0,
    activeSelection: [],
    parentStruct: {},
    workData: null,
  }),
  computed: {
    activeGroup() {
      return this.activeSelection.join('__');
    },
  },
  watch: {

  },
  methods: {
    openFullSize() {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) * 0.7;
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) * 0.7;
      window.openWindow({
        caption: 'Диаграмма',
        component: selfComponent,
        innerProps: {
          fullSizable: false,
          maxChartWidth: vw,
          maxDiagramHeight: vh,
          isVertical: this.isVertical,
          typeName: this.typeName,
          rawValues: this.rawValues,
        },
      });
    },
    getLevelList(levelNum) {
      let thisParent = this.parentStruct;
      let levelCounter = 0;
      while (levelNum - levelCounter > 0) {
        thisParent = thisParent[this.activeSelection[levelCounter]];
        levelCounter += 1;
      }
      const ans = thisParent == null ? [] : Object.keys(thisParent);
      this.activeSelection[levelNum] = thisParent[this.activeSelection[levelNum]] == null ? ans[0] : this.activeSelection[levelNum];
      return ans;
    },
    async updateWorkData() {
      const rawData = await window.ZForms.parseRaw(this.rawValues);

      let baseFields = Object.values(rawData.contentMeta.fields).filter((field) => field.childrenFields.length < 1);
      const firstField = baseFields[0];
      const colorField = baseFields[1].parent == null ? baseFields[1] : null;
      baseFields = baseFields.filter((field, idx) => idx > (colorField == null ? 0 : 1));
      const result = Array.from({length: baseFields.length / 2}, () => []);
      const colorCount = 10;
      let counter = 0;

      const groups = {};

      result.forEach((line, idx) => {
        if (idx % 2 == 0) counter = 0;

        rawData.content.forEach((contentRow) => {
          const s = contentRow.values[baseFields[idx * 2].attrName];
          const e = contentRow.values[baseFields[idx * 2 + 1].attrName];
          line.push({
            'view': contentRow.values[firstField.attrName],
            's': s ? s : 0,
            'e': e ? e : 0,
            'color': colorField == null ? hslToHex(160 + (1 - (counter % 11)/colorCount) * 160, 60, 50)+'f0' : contentRow.values[colorField.attrName],
          });
          counter += 1;
        });

        const parentList = getParentViewList(baseFields[idx * 2].parent.parent);
        this.maxLevel = Math.max(parentList.length, this.maxLevel);

        let thisParent = this.parentStruct;

        parentList.forEach((p) => {
          thisParent[p] = thisParent[p] == null ? {} : thisParent[p];
          thisParent = thisParent[p];
        });

        const elem = {
          'parent': baseFields[idx * 2].parent.view,
          'parents': parentList,
          'group': parentList.join('__'),
          'data': line,
        };

        groups[elem.group] = groups[elem.group] == null ? {data: [], meta: {}} : groups[elem.group];
        groups[elem.group].data.push(elem);
        groups[elem.group].meta.group = elem.group;
        groups[elem.group].meta.parents = parentList;
      });

      this.workData = groups;

      // console.log('this.workData', this);
    },
  },
  created() {
    this.updateWorkData();
  },
  props: {
    fullSizable: {
      default: true,
    },
    maxChartWidth: {
      default: 350,
      required: false,
    },
    maxDiagramHeight: {
      default: 250,
      required: false,
    },
    isVertical: {
      default: true,
    },
    typeName: {
      default: 'gantt',
      required: false,
    },
    rawSeries: {
      default: null,
    },
    rawPoints: {
      default: null,
    },
    rawValues: {
      default: {},
    },
  },
};

export default selfComponent;
</script>
